import {
  RECEIVE_LPS_CONFIGS_REQUEST,
  RECEIVE_LPS_CONFIGS_SUCCESS,
  RECEIVE_LPS_CONFIGS_ERROR,
  CREATE_EDIT_LPS_CONFIG_ERROR,
  CREATE_EDIT_LPS_CONFIG_REQUEST,
  CREATE_EDIT_LPS_CONFIG_SUCCESS,
  DELETE_LPS_CONFIG_REQUEST,
  DELETE_LPS_CONFIG_SUCCESS,
  DELETE_LPS_CONFIG_ERROR,
  RUN_PROCESSING_LPS_REQUEST,
  FINISH_PROCESSING_LPS_SUCCESS,
  FINISH_PROCESSING_LPS_ERROR,
  CHECK_LPS_USAGE_REQUEST,
  CHECK_LPS_USAGE_SUCCESS,
  CHECK_LPS_USAGE_ERROR,
  SET_LPS_LEAD_INDEX,
  RECALCULATE_DEFAULT_PROFILE,
  RESET_CURRENT_CALCULATION_REQUEST,
  RESET_CURRENT_CALCULATION_SUCCESS,
} from "../../../common/constants/action-constants";
import AlertService from "../../../common/services/notification.service";
import UserService from "../../../common/services/user.service";
import type { ApiError } from '../../../../types/api-error';
import type { StartCountLpsDataQuery } from '../../../common/components/lps-menu/types';

export type StartCountLPSDataRequestAction = {
  type: typeof RUN_PROCESSING_LPS_REQUEST;
  query: StartCountLpsDataQuery;
}

export type CheckLpsUsageRequestAction = {
  type: typeof CHECK_LPS_USAGE_REQUEST;
  needAlertFlag: boolean;
}

export type CheckLpsUsageSuccessAction = {
  type: typeof CHECK_LPS_USAGE_SUCCESS;
  canUseLps: any;
}

export type CheckLpsUsageErrorAction = {
  type: typeof CHECK_LPS_USAGE_ERROR;
  error: unknown;
}


/** receive LPS configs list **/
export const receiveLPSConfigsRequest = () => {
  return {
    type: RECEIVE_LPS_CONFIGS_REQUEST,
  };
};

export const receiveLPSConfigsSuccess = (lpsConfigs) => {
  return {
    type: RECEIVE_LPS_CONFIGS_SUCCESS,
    lpsConfigs,
  };
};

export const receiveLPSConfigsError = (error: unknown) => {
  return {
    type: RECEIVE_LPS_CONFIGS_ERROR,
    error,
  };
};

export const createEditLPSConfigsRequest = (data) => {
  return {
    type: CREATE_EDIT_LPS_CONFIG_REQUEST,
    data,
  };
};

export const createEditLPSConfigsSuccess = (message: string) => {
  AlertService.success(message);
  return {
    type: CREATE_EDIT_LPS_CONFIG_SUCCESS,
  };
};

export const createEditLPSConfigsError = (error: unknown) => {
  AlertService.error(`SOMETHING WENT WRONG. Error: ${error}`);
  return {
    type: CREATE_EDIT_LPS_CONFIG_ERROR,
    error,
  };
};

export const deleteLPSConfigRequest = (id) => {
  return {
    type: DELETE_LPS_CONFIG_REQUEST,
    id,
  };
};

export const deleteLPSConfigSuccess = (payload: {type: "success" | "info"; message: string}) => {
  return {
    type: DELETE_LPS_CONFIG_SUCCESS,
    payload,
  };
};

export const deleteLPSConfigError = (error: ApiError) => {
  return {
    type: DELETE_LPS_CONFIG_ERROR,
    error,
  };
};

export const startCountLPSDataRequest = (query: StartCountLpsDataQuery): StartCountLPSDataRequestAction => {
  return {
    type: RUN_PROCESSING_LPS_REQUEST,
    query,
  };
};

export const resetCurrentCalculationRequest = () => {
  // @ts-ignore
  const ident = UserService.LPCIdent;
  return {
    type: RESET_CURRENT_CALCULATION_REQUEST,
    ident,
  };
};

export const resetCurrentCalculationSuccess = (data) => {
  return {
    type: RESET_CURRENT_CALCULATION_SUCCESS,
    data,
  };
};

export const finishCountLPSDataSuccess = (result) => {
  return {
    type: FINISH_PROCESSING_LPS_SUCCESS,
    result: result,
  };
};

export const finishCountLPSDataError = (error: unknown) => {
  return {
    type: FINISH_PROCESSING_LPS_ERROR,
    error,
  };
};

export const checkLpsUsageRequest = (needAlertFlag = false): CheckLpsUsageRequestAction => {
   return {
    type: CHECK_LPS_USAGE_REQUEST,
    needAlertFlag,
   };
};

export const checkLpsUsageSuccess = (canUseLps: any): CheckLpsUsageSuccessAction => {
  // AlertService.info(canUseLps);
  return {
    type: CHECK_LPS_USAGE_SUCCESS,
    canUseLps,
  };
};

export const checkLpsUsageError = (error: unknown): CheckLpsUsageErrorAction => {
  return {
    type: CHECK_LPS_USAGE_ERROR,
    error,
  };
};

export const setLPSItem = (index) => {
  return {
    type: SET_LPS_LEAD_INDEX,
    indexLPSItem: index,
  };
};

// export const skipUnassignedLeadsFlag = (isSkipped) => {
//   console.log('isSkipped', isSkipped);
//   return {
//     type: SKIP_UNASSIGNED_LEADS_IN_LPS_RATING,
//     isSkipped,
//   };
// };

export const calcDefaultProfile = (isCalculated) => {
  return {
    type: RECALCULATE_DEFAULT_PROFILE,
    isCalculated,
  };
};
